import {CApiNotification} from './CApiNotification';

import type {JsonObject} from '../../../../HeliportJS/dist/models/json';
export class CTextChatApiNotification {
  addPosChannelEvent(fn: (params: JsonObject) => void) {
    CApiNotification.addEventListener('PositionChannel', 'TextChat', fn);
  }

  addPersonalEvent(fn: (params: JsonObject) => void) {
    CApiNotification.addEventListener('Personal', 'TextChat', fn);
  }

  addSystemEvent(fn: (params: JsonObject) => void) {
    CApiNotification.addEventListener('System', 'SystemChat', fn);
  }
}
